import * as React from 'react';
import { Form, Input } from 'library';
import { IFormData, IFormState, SystemFormDetail } from 'library/form/SystemFormDetail';
import { ColorPicker } from '@progress/kendo-react-inputs';

interface IDataModel extends IFormData {
    PrimaryKeyEncrypted?: string,
    Color?: string,
    SortOrder?: string,
    RowVersion?: string
}

export default class ChartColorForm extends SystemFormDetail<IDataModel> {

    constructor(props: any) {
        super(props);
    }

    initial = (): IFormState<IDataModel> => {
        return {
            formData: {
                PrimaryKeyEncrypted: (this.props.data && this.props.data.PrimaryKeyEncrypted) ? this.props.data.PrimaryKeyEncrypted : undefined
            },
        }
    }

    load = (data: IDataModel) => {
        if (data) {
            this.setState({
                formData: {
                    ...data,
                    PrimaryKeyEncrypted: data.PrimaryKeyEncrypted,
                    Color: data.Color,
                    SortOrder: data.SortOrder,
                    RowVersion: data.RowVersion,
                }
            })
        }
    }

    //rgbaToHex = (rgba) => {
    //    var parts = rgba.substring(rgba.indexOf("(")).split(","),
    //        r = parseInt(trim(parts[0].substring(1)), 10),
    //        g = parseInt(trim(parts[1]), 10),
    //        b = parseInt(trim(parts[2]), 10),
    //        a = parseFloat(trim(parts[3].substring(0, parts[3].length - 1))).toFixed(2);
    //    return ('#' + r.toString(16) + g.toString(16) + b.toString(16) + (a * 255).toString(16).substring(0, 2));
    //}

    handleChangeColorInput = (event: any, name: string, value: any, text: string) => {
        this.state.formData.Color = event.value;
    }

    render() {
        return (<>
            <Form
                label="Chart Colors"
                url={'ChartColors'}
                onLoad={this.load}
                showReview={false}
                primaryKeyEncrypted={this.state.formData.PrimaryKeyEncrypted}
                securityObject="Top.ChartColors"
                schema="Top" table="ChartColors"
                onInitialize={this.initialize}
                onClear={this.initialize}
                onValidate={this.validate}
                onPrepare={this.prepare}
                onRecordUpdated={this.onRecordUpdated} >

                <div className="col-md-3 col-6 mb-2">
                    <div className="col-md-3">
                        <label>Color:</label>
                    </div>
                    <div className="col-md-3">
                        <ColorPicker
                            label="Color"
                            id="Color"
                            name="Color"
                            view="gradient"
                            value={this.state.formData.Color}
                            onChange={this.handleChangeColorInput} />
                    </div>           
                </div>

                <div className="col-md-3 col-6 mb-2">
                    <Input
                        isRequired={true}
                        id="SortOrder"
                        name="SortOrder"
                        label='Sort Order'
                        labelClass="col-12"
                        componentClass="col-12"
                        onChange={this.handleChange}
                        value={this.state.formData.SortOrder}
                        validator={this.validator} />
                </div>
            </Form>
        </>)
    }
};